import React, { ChangeEvent, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./index.module.scss";
import { postSubTaskPunch, postUploadFile } from "../../../../api";
import { Loading, Note, Notification } from "@quark/design";
import Navigator from "../../../../component/navigator";
import { QRCodeCanvas } from "qrcode.react";
import example1 from "../../../../assets/punch/example1.png";
import example2 from "../../../../assets/punch/example2.png";
import useDocumentTitle from "../../../../hooks/use-document-title";

const TaskPunchPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { seasonId, subTaskId } = params;

  const fileInput = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = React.useState(false);

  useDocumentTitle("上传打卡结果");
  const fileSelect = () => {
    fileInput.current?.click();
  };

  const fileSelectChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files?.length) return;
    if (files.length > 5) {
      Notification.error("最多上传5张图片", { duration: 3000 });
      return;
    }
    // 文件不能大于5M
    if (Array.from(files).some((file) => file.size > 5 * 1024 * 1024)) {
      Notification.error("单张文件不能大于5M", { duration: 3000 });
      return;
    }
    // 只能上传图片格式
    if (Array.from(files).some((file) => !file.type.includes("image"))) {
      Notification.error("只能上传图片格式", { duration: 3000 });
      return;
    }

    const uploads = Array.from(files).map((file) => {
      return postUploadFile(file);
    });
    try {
      setUploading(true);
      const files = await Promise.all(uploads);
      const keys = files.map((file) => file.file_key).join(",");
      await postSubTaskPunch(Number(subTaskId), keys);
      Notification.success("提交打卡成功, 进入审核环节", { duration: 3000 });
      navigate(`/season/${seasonId}/tasks`);
    } catch (error) {
      Notification.error("上传失败, 请重试", { duration: 3000 });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={styles.container}>
      <Navigator activeKey="promotion" />
      <div className={styles.content}>
        <h1>今日打卡</h1>
        <div className={styles.tips}>点击按钮上传打卡截图👇</div>

        <input
          ref={fileInput}
          type="file"
          // multiple
          onChange={fileSelectChange}
          style={{ display: "none" }}
        />
        <div className={styles.button} onClick={fileSelect}>
          {uploading ? <Loading /> : "上传小红书打卡图"}
        </div>
        <div className={styles.body}>
          <div className={styles.qrcode}>
            <QRCodeCanvas
              size={240}
              value="https://mall.py2fun.com/buy/#/vip/open"
            />
            <div className={styles.tips}>微信扫码用手机打卡</div>
          </div>
          <div className={styles.main}>
            <h3>文案要求</h3>
            <p>
              完成今日学习笔记整理（或截学习过程图），
              <br />
              并带上话题 <span>#pythontip</span>
              <span>#哈希编程</span> <span>#python学习</span> （必填哦），
              <span>#编程</span> <span>#python</span> （可选的）
            </p>
            <Note
              className={styles.note}
              hideIcon
              content="我们鼓励大家自行根据学习收获做笔记，单篇笔记1周内收获点赞100+
              再额外奖励100元🧧哦"
            />
          </div>
        </div>
        <h3>打卡示例</h3>
        <div className={styles.examples}>
          <img src={example1} alt="" />
          <img src={example2} alt="" />
        </div>
      </div>
    </div>
  );
};

export default TaskPunchPage;
